export const PREVIEW_SIZE = {
  mobile: 1,
  desktop: 2,
}